import { useMutation } from "@apollo/client/react";
import { Box, IconicButton } from "@nulogy/components";
import DaysSelector from "components/common/DaysSelector";
import { GridBox6, StyledInput, StyledTimePicker } from "components/common/EditableListStyledComponents";
import FieldRow from "components/common/FieldRow";
import Form from "components/controls/Form";
import { insertShift } from "hooks/apollo/shift/helpers/handleUpdateShifts";
import { CreateShift } from "hooks/apollo/shift/shift.gql";
import React from "react";
import DateTime from "utils/DateTime";
import Time from "utils/Time";

export default function NewShift({ shiftId, onRemoveNewShift }) {
  const [createShift] = useMutation(CreateShift);

  const handleSave = ({ id, name, days, startTime, endTime }) => {
    const updatedStartTime = Time.to24Hour(startTime);
    const updatedEndTime = Time.to24Hour(endTime);
    const updatedDays = {};
    DateTime.DAYS_OF_WEEK.forEach((day) => {
      updatedDays[day] = days.includes(day);
    });

    return createShift({
      update: (proxy, { data }) => {
        const newShift = data.createShift.shift;

        insertShift(newShift, proxy);
      },
      variables: {
        endTime: updatedEndTime,
        id,
        name,
        startTime: updatedStartTime,
        ...updatedDays,
      },
    });
  };

  const removeNewShift = () => {
    onRemoveNewShift(shiftId);
  };

  return (
    <Form
      initialValues={{
        days: [],
        endTime: null,
        id: shiftId,
        name: "",
        startTime: null,
      }}
      onAfterSave={removeNewShift}
      onSave={handleSave}
    >
      {({ dirty }) => (
        <FieldRow data-testid="new-shift-row" marginBottom="0">
          <GridBox6>
            <StyledInput field="name" placeholder="Name" />
            <DaysSelector />
            <Box data-testid="start-time">
              <StyledTimePicker className="spec-shift-start-time" field="startTime" placeholder="Start Time" />
            </Box>
            <Box data-testid="end-time">
              <StyledTimePicker className="spec-shift-end-time" field="endTime" placeholder="End Time" />
            </Box>

            <Box paddingTop="x1">
              <IconicButton disabled={!dirty} icon="check" type="submit">
                Save
              </IconicButton>
            </Box>
            <Box paddingTop="x1">
              <IconicButton icon="close" onClick={removeNewShift} type="button">
                Cancel
              </IconicButton>
            </Box>
          </GridBox6>
        </FieldRow>
      )}
    </Form>
  );
}
